import { Card } from '../design-system/Card';
import { Text } from '../design-system/Text';
import { formatCurrency } from '../../utils/format';
import type { Challan } from '../../types';

interface PaymentSummaryCardProps {
  challans: Challan[];
}

export function PaymentSummaryCard({ challans }: PaymentSummaryCardProps) {
  const subtotal = challans.reduce((sum, c) => sum + c.amount, 0);
  const fee = Math.round(subtotal * 0.02);
  const total = subtotal + fee;

  return (
    <Card padding="md" elevation={2} className="mx-4 mt-4">
      <Text variant="title">Payment Summary</Text>

      <div className="mt-4 space-y-3">
        {challans.map((c) => (
          <div key={c.id} className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <Text variant="body-medium" className="truncate">{c.violation}</Text>
              <Text variant="caption" color="secondary">{c.authority}</Text>
            </div>
            <Text variant="body-medium">{formatCurrency(c.amount)}</Text>
          </div>
        ))}
      </div>

      <hr className="my-4 border-slate-100 dark:border-slate-700" />

      <div className="space-y-2">
        <div className="flex justify-between">
          <Text variant="body" color="secondary">Subtotal</Text>
          <Text variant="body-medium">{formatCurrency(subtotal)}</Text>
        </div>
        <div className="flex justify-between">
          <Text variant="body" color="secondary">Convenience fee</Text>
          <Text variant="body-medium">{formatCurrency(fee)}</Text>
        </div>
        <div className="flex justify-between pt-2">
          <Text variant="body-medium">Total payable</Text>
          <Text variant="title" color="primary-brand">{formatCurrency(total)}</Text>
        </div>
      </div>
    </Card>
  );
}
